<template>
  <div class="serveList">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div style="width: 1200px; margin: 0 auto; height: 53px">
      <div class="crumbs">
        <span>当前位置：</span>
        <span @click="toHome">首页 ></span>
        <span @click="toServe">服务 ></span>
        <span @click="toServeList" style="color: #333333">{{ catalogueName }} </span>
      </div>
    </div>
    <div class="search-wrap">
      <div class="search-input">
        <input type="text" v-model="realName" placeholder="请输入关键字" />
        <button @click="search">搜索</button>
      </div>
    </div>
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item.servicesId)"
      >
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" :src="item.coverImg" />
          </div>
          <div class="text">
            <div class="text-b">{{ item.servicesName }}</div>
            <div class="text-s"><span>{{ item.baseRemark }}</span></div>
          </div>
          <button class="detailBtn" @click="toDetail(item.servicesId)">
            查看详情
          </button>
        </div>
      </li>
    </ul>
    <div style="width: 100%; height: 30px"></div>
  </div>
</template>

<script>
import navigation from "@/components/common/navigation";

export default {
  name: "serveList",
  components: {
    navigation,
  },
  data() {
    return {
      catalogueName: "",
      catalogueEnglishName: "",
      catalogueId: "",
      list: [],
      realName: ''
    };
  },
  methods: {
    search() {
      // activityName 搜索
      let catalogueId = this.$route.query.id;
      this.$axios
        .post("/v1/cloud/common/services/more", {
          catalogueId,
          servicesName: this.realName
        })
        .then(({ data }) => {
          if (data) {
            this.catalogueName = data.catalogueName;
            this.catalogueEnglishName = data.catalogueEnglishName;
            this.catalogueId = data.catalogueId;
            this.list = data.servicesList;
          }
        })
        .catch((error) => {
          // this.$message({
          //     message: error.response.data.message,
          //     type: 'warning'
          // });
          this.$message.error(error.response.data.message);
        });
    },

    toDetail(servicesId) {
      let catalogueId = this.$route.query.id;
      this.$router.push({
        path: "/serveDetail",
        query: {
          servicesId,
          catalogueId,
          catalogueName: this.catalogueName,
        },
      });
    },
    toHome() {
      sessionStorage.setItem("tabIndex", 1);
      this.$router.push("/");
    },
    toServe() {
      this.$router.push("/serve");
    },
    toServeList() {
      this.$router.push("/serveList");
    },
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    };
    this.search()
    // let catalogueId = this.$route.query.id;
    // this.$axios
    //   .post("/v1/cloud/common/services/more", {
    //     catalogueId,
    //   })
    //   .then(({ data }) => {
    //     if (data) {
    //       this.catalogueName = data.catalogueName;
    //       this.catalogueEnglishName = data.catalogueEnglishName;
    //       this.catalogueId = data.catalogueId;
    //       this.list = data.servicesList;
    //     }
    //   })
    //   .catch((error) => {
    //     // this.$message({
    //     //     message: error.response.data.message,
    //     //     type: 'warning'
    //     // });
    //     this.$message.error(error.response.data.message);
    //   });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.search-wrap {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
    .search-input {
      margin-left: 61px;
      margin-bottom: 24px;
      input {
        width: 600px;
        outline: none;
        height: 40px;
        vertical-align: middle;
        text-indent: 11px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        border-radius: 3px;
      }
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      button {
        width: 100px;
        height: 40px;
        background: #3476c1;
        border-radius: 0px 3px 3px 0px;
        outline: none;
        border: none;
        text-align: center;
        line-height: 40px;
        margin-left: -1px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
.serveList {
  width: 100%;
  // position: relative;
  background-color: #f5f5f5;
  .crumbs {
    width: 500px;
    font-size: 14px;
    margin-top: 20px;
    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
    }
  }
  .head {
    width: 1200px;
    height: 36px;
    margin: 20px auto;
    text-align: center;
    // margin-left: 360px;
    .blueLine {
      width: 4px;
      height: 26px;
      background: rgba(15, 155, 241, 1);
      float: left;
      margin-top: 13px;
    }
    .headCH {
      float: left;
      // width:78px;
      // height:19px;
      font-size: 36px;
      font-family: MicrosoftYaHei;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-left: 20px;
    }
    .headEN {
      // width:199px;
      // height:18px;
      font-size: 24px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(101, 101, 101, 1);
      float: left;
      margin-left: 20px;
      margin-top: 16px;
    }
  }
  ul {
    width: 1200px;
    list-style-type: none;
    margin: 30px auto;
    height: auto;
    // overflow: hidden;
    li {
      padding: 20px;
      width: 1200px;
      box-sizing: border-box;
      margin-bottom: 20px;
      background-color: #fff;
      .li-wrap {
        height: 230px;
        width: 100%;
        position: relative;
        cursor: pointer;
        img {
          height: 230px;
          width: 370px;
          float: left;
        }
        .text {
          width: 760px;
          float: left;
          padding: 10px 20px 20px;
          .text-b {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .text-s {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            height: 76px;
            overflow: hidden;
          }
          .people {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            margin: 5px 0;
            span {
              color: #0f9bf1;
              font-size: 18px;
              margin-right: 64px;
            }
          }
          .date {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            span {
              color: #333333;
            }
          }
        }
        .detailBtn {
          width: 150px;
          height: 40px;
          border: 1px solid #5fc0e4;
          border-radius: 3px;
          line-height: 40px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5fc0e4;
          outline: none;
          position: absolute;
          right: 30px;
          bottom: 20px;
          background-color: #fff;
        }
        .detailBtn:hover {
          color: #fff;
          background: rgba(0, 0, 0, 1);
        }
      }
    }
    li:hover {
      .li-wrap {
        background-color: #f5f5f5;
        .detailBtn {
          color: #fff;
          background-color: #5fc0e4;
        }
      }
    }
  }
}
</style>